import React, { useEffect } from 'react';
import '../styles/Pages/About.css';

const About = () => {
  useEffect(() => {
    document.title = 'About Us - Pentagram Infotech';
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute(
        'content',
        'Learn about Pentagram Infotech - Our history, mission, vision, and values. 25+ years of delivering IT solutions.'
      );

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "About Pentagram Infotech",
      "description": "Information about Pentagram Infotech history, mission, vision, and values",
      "publisher": {
        "@type": "Organization",
        "name": "Pentagram Infotech Private Limited",
        "foundingDate": "2001",
        "numberOfEmployees": "50+",
        "description": "Leading IT solutions provider"
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const values = [
    {
      id: 1,
      title: 'Innovation',
      description: 'We adopt modern technologies to deliver future-ready solutions.',
      icon: 'bi-lightbulb'
    },
    {
      id: 2,
      title: 'Excellence',
      description: 'We follow strict quality standards across all services.',
      icon: 'bi-award'
    },
    {
      id: 3,
      title: 'Integrity',
      description: 'We operate with honesty, transparency, and ethics.',
      icon: 'bi-shield-check'
    },
    {
      id: 4,
      title: 'Collaboration',
      description: 'We work closely with clients to achieve business goals.',
      icon: 'bi-people'
    },
    {
      id: 5,
      title: 'Customer Focus',
      description: 'Client success drives every decision we make.',
      icon: 'bi-heart'
    },
    {
      id: 6,
      title: 'Growth',
      description: 'We promote continuous improvement and learning.',
      icon: 'bi-graph-up'
    }
  ];

  return (
    <div className="about-page page-transition">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="row align-items-center min-vh-60">
            <div className="col-lg-8 mx-auto text-center">
              <h1 className="page-title">About Pentagram Infotech</h1>
              <p className="page-subtitle">
                Delivering reliable and scalable IT solutions since 2001.
              </p>
              <div className="hero-stats">
                <div className="stat">
                  <span className="number">2001</span>
                  <span className="label">Founded</span>
                </div>
                <div className="stat">
                  <span className="number">500+</span>
                  <span className="label">Projects</span>
                </div>
                <div className="stat">
                  <span className="number">50+</span>
                  <span className="label">Professionals</span>
                </div>
                <div className="stat">
                  <span className="number">200+</span>
                  <span className="label">Clients</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="company-story section-padding">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <span className="section-label">Our Story</span>
              <h2 className="section-title">Technology Excellence Since 2001</h2>
              <p>
                Pentagram Infotech was founded to help businesses grow through technology.
                Over the years, we evolved into a full-service IT solutions provider.
              </p>
              <p>
                Our focus remains on innovation, quality delivery, and long-term client success.
              </p>
            </div>
            <div className="col-lg-6">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c"
                alt="Pentagram Infotech Office"
                className="img-fluid rounded"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision section-padding bg-light">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mb-4">
              <h3>Our Mission</h3>
              <p>
                To deliver secure, scalable, and innovative IT solutions that drive business growth.
              </p>
            </div>
            <div className="col-lg-6">
              <h3>Our Vision</h3>
              <p>
                To be a trusted global IT partner known for technology excellence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="core-values section-padding">
        <div className="container">
          <div className="section-header text-center mb-5">
            <h2 className="section-title">Our Core Values</h2>
          </div>

          <div className="values-grid">
            {values.map(value => (
              <div className="value-card" key={value.id}>
                <i className={`bi ${value.icon}`}></i>
                <h4>{value.title}</h4>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
